import AudiencesDrawer from "@containers/oraculo/audiences/AudiencesDrawer";
import { useState } from "react";

export const SavedAudienceForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [selectedAudience, setSelectedAudience] = useState(null);

  const fresh_node = (changed_node) => ({
    ...node,
    data: {
      ...(node.data || {}),
      ...changed_node,
    },
  });

  const onSaveNode = (audience) => {
    setSelectedAudience(audience);
    onSave(
      fresh_node({
        audienceId: audience.id,
        name: audience.name,
      })
    );
  };

  return (
    <AudiencesDrawer
      isSelection
      visible={visible}
      onClose={() => onClose()}
      openAudience={(audience) => onSaveNode(audience)}
      viewAudience
      selectedAudience={selectedAudience || node?.data?.audienceId}
    />
  );
};
